import "./index.scss";
import { PageBack } from "components/PageBack";
import { useNavigate } from "react-router-dom";
import Countdown from "react-countdown";

import { useSelector } from "react-redux";
import { AppState, useAppDispatch } from "reducers";
import avatar from "assets/avatar.png";
import {
  activateMining,
  getMiningInfo,
  releaseMining,
  unLockMining,
} from "services/apis/mining";
import { useEffect, useState } from "react";
import level0 from "assets/mining/level_0.png";
import level3 from "assets/mining/level_3.png";
import level6 from "assets/mining/level_6.png";
import level8 from "assets/mining/level_8.png";

import lock from "assets/mining/lock.png";
import clock from "assets/mining/clock.png";
import moenyBag from "assets/mining/money-bag.png";
import { formatCompactNumber } from "utils";
import { updateAmountAndLevel } from "reducers/auth.reducer";
import { toast } from "react-toastify";

type MiningType = {
  reward: number;
  unlockAmount: number;
  status: number; // 0: inactive, 1: active
  active: null | Date;
  fromLevel: number;
  toLevel: number;
  id: string;
  historyId: string;
};

export function Mining() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useSelector((state: AppState) => state.auth);
  const [minings, setMinings] = useState<Array<MiningType>>([]);

  const _updateMinings = (data: any) => {
    const _data = data
      ?.map((item: any) => ({
        status: item.status,
        active: item.his ? item.his.active : null,
        fromLevel: item.mining.from,
        toLevel: item.mining.to,
        id: item.mining?.id,
        reward: Number(item.mining.reward),
        unlockAmount: Number(item.mining.unlock_amount),
        historyId: item.his ? item.his.id : "",
      }))
      .sort((a: any, b: any) => a.fromLevel - b.fromLevel);

    setMinings(_data);
  };

  const _loadMiningData = async () => {
    const response = await getMiningInfo();
    _updateMinings(response.data);
  };

  const showImage = (level: number) => {
    switch (level) {
      case 0:
        return level0;
      case 3:
        return level3;
      case 6:
        return level6;
      case 8:
        return level8;
      default:
        return level0;
    }
  };

  const handleMining = async (mining: MiningType) => {
    const status = mining.status;
    const miningId = mining.id;
    switch (status) {
      case 0: // inactive
        if (user.amount < mining.unlockAmount) {
          toast.error("You don't have enough balance to unlock this card.");
          return;
        }
        const res_unlock = await activateMining({ miningId });
        dispatch(updateAmountAndLevel({ level: user.level, amount: user.amount - mining.unlockAmount}))
        _updateMinings(res_unlock.data);
        break;
      case 1: // active
        //
        if (mining.historyId) {
          const today = new Date();
          const activeDate = new Date(mining.active || "");
          const between = activeDate.getTime() - today.getTime();
          if (between > 0) {
            toast.warning("Please wait");
          } else {
            const res_release = await releaseMining({ history: mining.historyId });
            _updateMinings(res_release.data);

            const userData = res_release.user;

            dispatch(
              updateAmountAndLevel({
                amount: userData.amount,
                level: userData.level,
              })
            );
          }

          return;
        }

        const _res_mining = await unLockMining({ miningId });
        _updateMinings(_res_mining.data);

        break;
      default:
        break;
    }
  };

  const renderMining = (mining: MiningType) => {
    const today = new Date();
    const activeDate = new Date(mining.active || "");
    const between = activeDate.getTime() - today.getTime();
    return (
      <div className="flex relative" onClick={() => handleMining(mining)}>
        <img
          src={showImage(mining.fromLevel)}
          alt=""
          className="w-full h-auto"
        />
        {mining.status == 0 && (
          <>
            <div className="w-full h-full bg-black/60 absolute rounded-[30px] backdrop-blur-sm" />
            <div className="w-full h-full absolute flex flex-col items-center justify-center p-2">
              <div className="flex italic w-full ">
                <label className="text-white text-[13px] font-[600] bg-[#0007481F] backdrop-blur-sm border border-1 rounded-[45px] border-white px-2">
                  {`Lvl.${mining.fromLevel}`}
                </label>
              </div>
              <div className="flex items-center justify-center">
                <img src={lock} alt="" />
              </div>
              <div className="flex items-center text-white font-[600] text-[32px] italic">
                <img src={avatar} alt="" className="w-[40px] h-40px]" />
                <label>{mining.unlockAmount}</label>
              </div>
            </div>
          </>
        )}
        {mining.status === 1 && mining.active && (
          <>
            <div className="w-full h-full bg-black/60 absolute rounded-[30px] backdrop-blur-lg border border-[2px] border-[#FFFFFF4D]" />
            <div className="w-full h-full absolute flex flex-col items-center justify-center p-2 gap-[10px]">
              {between > 0 && (
                <>
                  <div className="flex">
                    <Countdown
                      date={new Date(mining.active)}
                      renderer={({ days, hours, minutes, seconds }) => (
                        <div className="text-white italic font-[600] flex gap-[10px] justify-center">
                          <div className="flex flex-col items-center">
                            <p className="text-[32px]">{hours}</p>
                            <p className="text-[14px]">Hours</p>
                          </div>
                          <div className="flex flex-col text-[32px]">:</div>
                          <div className="flex flex-col items-center">
                            <p className="text-[32px]">{minutes}</p>
                            <p className="text-[14px]">Minutes</p>
                          </div>
                          <div className="flex flex-col text-[32px]">:</div>

                          <div className="flex flex-col items-center">
                            <p className="text-[32px]">{seconds}</p>
                            <p className="text-[14px]">Seconds</p>
                          </div>
                        </div>
                      )}
                    />
                  </div>
                  <div className="flex">
                    <img src={clock} alt="" />
                  </div>
                </>
              )}
              {between <= 0 && (
                <>
                  <div className="font-[500] text-[25px] text-white">
                    Collect coins
                  </div>
                  <div>
                    <img src={moenyBag} alt="" />
                  </div>
                </>
              )}
            </div>
          </>
        )}
        {mining.status === 2 && (
          <>
            <div className="w-full h-full unlocked-bg absolute rounded-[30px] " />
            <div className="w-full h-full absolute flex flex-col items-center justify-center p-2 gap-[10px]">
              <p className="text-[32px] text-white font-[600] italic">
                Unlocked
              </p>
            </div>
          </>
        )}
      </div>
    );
  };

  useEffect(() => {
    _loadMiningData();
  }, []);

  return (
    <>
      <div className="mining-container">
        <div className="flex justify-between w-full">
          <div className="flex items-center">
            <img src={avatar} alt="" className="w-[40px] h-[40px]" />
            <label className="text-white font-[700] text-[20px]">
              {formatCompactNumber(user.amount, {})}
            </label>
          </div>
          <div className="flex items-center">
            <PageBack
              onBack={() => navigate("/play")}
              classname="w-[20px] h-[20px]"
            />
          </div>
        </div>

        <div className="flex flex-col w-full gap-[20px] relative">
          {minings.map((mining, index) => (
            <div key={index}>{renderMining(mining)}</div>
          ))}
        </div>
      </div>
    </>
  );
}
